<template>


  <div class="yazdirtable Aski">

    <el-row v-if="Hesap_id!=6" :gutter="24" class="mb-3">
      <el-col :span="12">
        <h5 class="text-left">{{ Fatura.BinaAdi }}<br>{{ Fatura.aciklama }}<br> ASKI LİSTESİ</h5>
      </el-col>
      <el-col :span="12" class="text-right">
        <img :src="Logo" width="50%">
      </el-col>
    </el-row>
    <div v-if="Hesap_id==6">
      <el-row :gutter="24" class="mb-3">
        <el-col :span="12" class="text-left">
          <img src="https://cdn.mudu.pro/Design/yapifen/ypaskilogo.svg" class="YpImage">
        </el-col>
        <el-col :span="12" class="text-right">
          <img src="https://cdn.mudu.pro/Design/yapifen/ypaskilogo2.svg" class="YpImage">
        </el-col>
      </el-row>

      <el-row :gutter="24" class="mb-0">
        <el-col :span="12">
          <h5 class="text-left">{{ Fatura.BinaAdi }}<br>{{ Fatura.aciklama }} ASKI LİSTESİ</h5>
        </el-col>
        <el-col :span="12">
          <h5 class="pull-right text-right">
            <small class="d-block" style="font-size: 12px">Toplam Fatura</small><b>{{ Fatura.tutar }}</b>
          </h5>
        </el-col>
      </el-row>
    </div>
    <table class="table table-bordered">
      <thead>
      <tr>
        <th :colspan="Fatura.eAciklama?11:10" class="text-center">FATURA/DÖNEM BİLGİLERİ</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <small class="d-block">Son Ödeme Tarihi</small>
          <b style="font-size: 12px">{{ Fatura.starih }}</b>
        </td>

        <td class="text-right">
          <small class="d-block">Hesaplanan Enerji</small>
          <b style="font-size: 12px">{{ AltToplam.Hesap }} <sup>kWh</sup></b>
        </td>

        <td class="text-right">
          <small class="d-block">Enerji Birim</small>
          <b style="font-size: 12px">{{ AltToplam.Birim }} <sup>TL</sup></b>
        </td>
        <td class="text-right">
          <small class="d-block">Kapalı Alan</small>
          <b style="font-size: 12px">{{ AltToplam.KapaliAlan }}<sup>m2</sup></b>
        </td>

        <td class="text-right" v-if="Fatura.SicakSu">
          <small class="d-block">Şebeke Suyu</small>
          <b style="font-size: 12px">{{ Fatura.SuBirim }}<sup>TL</sup></b>
        </td>
        <td class="text-right" v-if="Fatura.SicakSu">
          <small class="d-block">Su Sarfiyat</small>
          <b style="font-size: 12px">{{ Fatura.OnayBilgi.Toplam.sBirim }}<sup>M3</sup></b>
        </td>
        <td class="text-right" v-if="Fatura.SicakSu">
          <small class="d-block">Şebeke Suyu Isıtma</small>
          <b style="font-size: 12px">{{ AltToplam.sTuketim }}<sup>TL</sup></b>
        </td>

        <td class="text-right" v-if="Fatura.eAciklama">
          <small class="d-block">{{ Fatura.eAciklama }}</small>
          <b style="font-size: 12px"> {{ Fatura.eTutar }}<sup>TL</sup></b>
        </td>
        <td class="text-right" v-if="Fatura.Tur==1">
          <small class="d-block">Ortak Alan</small>
          <b style="font-size: 12px"><sup>%{{ Fatura.oAlan }}</sup> {{ AltToplam.oAlan }}<sup>TL</sup></b>
        </td>
        <td class="text-right" v-if="Fatura.Tur==2">
          <small class="d-block">Su Ortak Alan</small>
          <b style="font-size: 12px"><sup>%{{ Fatura.oAlan }}</sup> {{ AltToplam.SuOrtak }}<sup>TL</sup></b>
        </td>
      </tr>
      </tbody>
    </table>

    <table class="table table-bordered">
      <thead>
      <tr>
        <th colspan="3" class="text-center">BİLGİ</th>
        <th :colspan="Fatura.MuafPay?8:7" v-if="Fatura.Tur==1" class="text-center">ISINMA</th>
        <th :colspan="Fatura.Tur==2?6:5" v-if="Fatura.SicakSu" class="text-center">SICAK SU</th>
        <th :colspan="Fatura.eTutar?3:2" class="text-center">DİĞER</th>
      </tr>
      <tr>
        <th>NO</th>
        <th>İSİM SOYİSİM</th>
        <th>M2</th>

        <th class="text-right" v-if="Fatura.Tur==1 && !Fatura.PayOlcer">İLK</th>
        <th class="text-right" v-if="Fatura.Tur==1 && !Fatura.PayOlcer">SON</th>
        <th class="text-right" v-if="Fatura.Tur==1">FARK</th>
        <th class="text-right" v-if="Fatura.Tur==1">MANÜPLASYON</th>
        <th class="text-right" v-if="Fatura.Tur==1">ENERJİ</th>
        <th class="text-right" v-if="Fatura.Tur==1">TÜKETİM</th>
        <th class="text-right" v-if="Fatura.Tur==1">ORTAK ALAN</th>
        <th class="text-right" v-if="Fatura.MuafPay">MUAF MESKEN PAYI</th>

        <th class="text-right" v-if="Fatura.SicakSu">İLK</th>
        <th class="text-right" v-if="Fatura.SicakSu">SON</th>
        <th class="text-right" v-if="Fatura.SicakSu">FARK</th>
        <th class="text-right" v-if="Fatura.SicakSu">TÜKETİM</th>
        <th class="text-right" v-if="Fatura.Tur==2">ORTAK ALAN</th>

        <th class="text-right" v-if="Fatura.SicakSu">ŞEBEKE</th>
        <th class="text-right" v-if="Fatura.eTutar>0">{{ Fatura.eAciklama }}</th>
        <th class="text-right">HİZMET BEDELİ</th>
        <th class="text-right">ÖDENECEK</th>

      </tr>
      </thead>
      <tbody>
      <tr v-for="f in FaturaDokum">
        <td>{{ f.kNo }}</td>
        <td>{{ f.AdSoyad }}</td>
        <td>{{ f.m2 }}<sup>m2</sup></td>

        <td class="text-right" v-if="Fatura.Tur==1 && !Fatura.PayOlcer">{{ f.KalSayac.Ilk }}<sup>kWh</sup></td>
        <td class="text-right" v-if="Fatura.Tur==1 && !Fatura.PayOlcer">{{ f.KalSayac.Son }}<sup>kWh</sup></td>
        <td class="text-right" v-if="Fatura.Tur==1"><b>{{ f.KalSayac.Tuketim }}</b><sup>kWh</sup>
          <i v-if="f.iFark>1"
             class="el-icon-warning pull-left"></i>
          <i v-if="f.UyariIcon"
             :class="f.UyariIcon" class="pull-left"></i>

        </td>
        <td class="text-right" :class="f.iFark>0?'bg-warning':''" v-if="Fatura.Tur==1">{{ f.Derece }}<sup>kWh</sup></td>
        <td class="text-right"  v-if="Fatura.Tur==1"><b>{{ f.KalSayac.Fark }}</b><sup>kWh</sup>
        <td class="text-right" v-if="Fatura.Tur==1">{{ f.tUcret }}<sup>TL</sup></td>
        <td class="text-right" v-if="Fatura.Tur==1">{{ f.oAlan }}<sup>TL</sup></td>


        <td class="text-right" v-if="Fatura.MuafPay">{{ f.MuafUcret }}<sup>TL</sup></td>

        <td class="text-right" v-if="Fatura.SicakSu">{{ (f.SuSayac.Ilk / 1000).toFixed(2) }}<sup>M3</sup></td>
        <td class="text-right" v-if="Fatura.SicakSu">{{ (f.SuSayac.Son / 1000).toFixed(2) }}<sup>M3</sup></td>
        <td class="text-right" v-if="Fatura.SicakSu">
          {{ f.SuSayac.Fark ? ((f.SuSayac.Fark / 1000).toFixed(2)) : '0.00' }}<sup>M3</sup>
        </td>
        <td class="text-right" v-if="Fatura.SicakSu">{{ f.sTuketim ? f.sTuketim : '0.00' }}<sup>TL</sup></td>
        <td class="text-right" v-if="Fatura.Tur==2">{{ f.SuOrtak ? f.SuOrtak : '0.00' }}<sup>TL</sup></td>

        <td class="text-right" v-if="Fatura.SicakSu">{{ f.sSebeke ? f.sSebeke : '0.00' }}<sup>TL</sup></td>
        <td class="text-right" v-if="Fatura.eTutar>0">{{ f.eTutar }}<sup>TL</sup></td>
        <td class="text-right">{{ f.Okuma }}<sup>TL</sup></td>
        <td class="text-right">{{ f.Odenecek }}<sup>TL</sup></td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th :colspan="5" class="text-right">ALT TOPLAM</th>
        <th class="text-right" v-if="Fatura.Tur==1">{{ AltToplam.Enerji }}<sup>kWh</sup></th>
        <th class="text-right" v-if="Fatura.Tur==1">{{ AltToplam.Derece }}<sup>kWh</sup></th>

        <th v-if="Fatura.Tur==1" class="text-right">{{ AltToplam.Hesap }} <sup>kWh</sup></th>
        <th class="text-right" v-if="Fatura.Tur==1">{{ AltToplam.tUcret }}<sup>TL</sup></th>
        <th class="text-right" v-if="Fatura.Tur==1">{{ AltToplam.oAlan }}<sup>TL</sup></th>
        <th class="text-right" v-if="Fatura.MuafPay">{{ AltToplam.MuafUcret }}<sup>TL</sup></th>
        <th class="text-right" v-if="Fatura.Tur==1 & Fatura.SicakSu">{{ Fatura.OnayBilgi.Toplam.sBirim }}<sup>M3</sup>
        </th>
        <th class="text-right" v-if="Fatura.SicakSu">{{ AltToplam.sTuketim }}<sup>TL</sup></th>
        <th class="text-right" v-if="Fatura.Tur==2">{{ AltToplam.SuOrtak }}<sup>TL</sup></th>

        <th class="text-right" v-if="Fatura.SicakSu">{{ AltToplam.sSebeke }}<sup>TL</sup></th>
        <th class="text-right" v-if="Fatura.eTutar>0">{{ Fatura.eTutar }}<sup>TL</sup></th>
        <th class="text-right">{{ AltToplam.Okuma }}<sup>TL</sup></th>
        <th class="text-right">{{ AltToplam.Odenecek }}<sup>TL</sup></th>
      </tr>
      </tfoot>
    </table>
    <p style="font-size: 12px;margin:0;text-align: center">
      <b>Terimler ve Anlamları; </b> <br>
      <i class="el-icon-warning"></i> 15Derece kuralına göre hesaplandı.
      <i class="el-icon-caret-top"></i> Yüksek tüketim tespit edildi. Lütfen Servis ile iletişime geçiniz.
      <i class="el-icon-caret-bottom"></i> Düşük tüketim tespit edildi. Lütfen Servis ile iletişime geçiniz.
    </p>

  </div>
</template>

<script>
import LazerReklam from "./LazerReklam";
import LazerHeaderLogo from "./LazerHeaderLogo";

export default {
  components: {LazerHeaderLogo, LazerReklam},
  props: ['Fatura', 'AltToplam', 'FaturaDokum', 'Hesap_id', 'Logo'],
  methods: {
    ParametreKaldir() {
      $('.hesaplamaparametre').remove()
    }
  }
}
</script>

<style scoped>
.yazdirtable {
  display: block;
}

.YpImage {
  max-height: 80px;
  max-width: 80%;
}

</style>



// WEBPACK FOOTER //
// src/components/Pack/Esayac/BinaHesaplamaDokumu.vue